import { ORDERS_ROUTES } from '@/router/routes'
import customersRoutes from '@/router/routing/customersRoutes'
import homeRoutes from '@/router/routing/homeRoutes'
import ordersRoutes from '@/router/routing/ordersRoutes'
import productionLinesRoutes from '@/router/routing/productionLinesRoutes'
import productsRoutes from '@/router/routing/productsRoutes'
import tagProducerAdminRouting from '@/router/routing/tagProducerAdminRouting'
import templateRoutes from '@/router/routing/templateRoutes'
import {
    adminRouting,
    authenticationRoutes,
    detectionRouting,
    devicesRoutes,
    organizationRouting
} from '@rfc/rfc-components-library/router'

import i18n from '@/locales/i18n'
import accountRoutes from '@/router/routing/accountRoutes'
import setupStore from '@/store'
import { DashboardLayout } from '@rfc/rfc-components-library'
import {
    EAuthActions,
    EAuthMutations,
    EStoreGlobalModules
} from '@rfc/rfc-components-library/store'
import type { UserDataModel } from '@rfc/rfc-components-library/types'
import { getItemFromStorage } from '@rfc/rfc-components-library/utils'
import moment from 'moment'
import { createRouter, createWebHistory, type Router } from 'vue-router'
import { menuRoutesTop } from './menuRoutes'

export const BASE_URL = '/'
export const LOGIN_URL = '/login'
export const HOME_URL = '/home'

const router: Router = createRouter({
    history: createWebHistory(import.meta.env?.BASE_URL),
    routes: [
        ...authenticationRoutes('', {
            loginProps: {
                goToUrl: ORDERS_ROUTES.baseUrl
            }
        }),
        {
            path: BASE_URL,
            component: DashboardLayout,
            props: {
                routes: menuRoutesTop
            },
            meta: {
                title: ''
            },
            children: [
                ...homeRoutes,
                ...customersRoutes,
                ...ordersRoutes,
                ...productsRoutes,
                ...productionLinesRoutes,
                ...templateRoutes,
                ...organizationRouting,
                ...devicesRoutes,
                ...detectionRouting,
                ...adminRouting(tagProducerAdminRouting),
                ...accountRoutes
            ]
        },
        {
            path: '/:catchAll(.*)',
            name: 'catchPage',
            redirect: '/'
        }
    ]
})

router.beforeEach(async (to, from, next) => {
    // redirect to login page if the user is not logged yet

    const user = getItemFromStorage<UserDataModel>('user')

    if (!setupStore(router)?.state?.authentication?.loggedIn && user)
        moment().isAfter(user.expires_at)
            ? setupStore(router)?.dispatch(
                  `${EStoreGlobalModules.AUTHENTICATION}/${EAuthActions.LOGOUT}`
              )
            : setupStore(router)?.commit(
                  `${EStoreGlobalModules.AUTHENTICATION}/${EAuthMutations.LOGIN_SUCCESS}`,
                  setupStore(router)?.state?.authentication?.accessToken
              )

    const loggedIn = setupStore(router)?.state.authentication.loggedIn

    if (to.meta.authRequired && !loggedIn) return next('/login')
    if (to.meta.guestRoute && loggedIn) return next('/')
    if (
        (!to.meta.permission && !to.meta.permissions) ||
        (to.meta.permissions as string[])?.find(item => user?.permissions?.includes(item)) ||
        user?.permissions?.includes(to.meta.permission as string)
    )
        return next()
    return next(from)
})

router.afterEach(
    async to => (document.title = to.meta.title ? i18n.global.t(to.meta.title) : 'Tag Producer')
)

export default router
